<template>
    <div>
        <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5">
        </base-header>

        <b-card style="margin: 20px">
            <b-card-body>
                <div class="row form-group">
                    <div class="col-md-12">
                        <label>Nombre Banco</label> 
                        <base-input v-model="BankName"></base-input>
                    </div>
                </div>   
                <div class="row form-group">
                    <div class="col-md-12">
                        <label>CBU</label> 
                        <base-input v-model="CBU" v-numericOnly placeholder="0"></base-input>
                    </div>
                </div>   
                <div class="row form-group">
                    <div class="col-md-12">
                        <label>Descripción</label> 
                        <base-input v-model="Description"></base-input>
                    </div>
                </div>   

                <div class="row form-group">
                    <div class="col-md-12">
                        <goback-button @click="goBack"></goback-button>
                        <save-button @click="addUpdate"></save-button>
                    </div>
                </div>
            </b-card-body>
        </b-card>       

    </div>
</template>

<script>
  import axiosHelpers from '@/helpers/axiosHelpers';
  import notificationHelpers from '@/helpers/notificationHelpers';

  export default { 
    name: 'AddUpdateBank',
    props: {
      title: String,
      EntityIDProp: Number,
    },
    directives: {
        
    },
    components: {},
    
    data() {
      return {
        EntityID: this.EntityIDProp,
        BankName: '',
        CBU: '',
        Description: ''
      }
    },
    methods: {
        
        isUpdate()
        {
            return (this.EntityID > 0);
        },

        goBack()
        {
            this.$router.push('bancos');
        },

        getData()
        {
            let self = this;
            if(this.isUpdate())
            {
                axiosHelpers.axiosPost('Supplier/GetSupplierBankAccount', {EntityID: self.EntityID}, this, function(response) { 
                    self.EntityID = response.ResponseVM.EntityID; 
                    self.BankName = response.ResponseVM.BankName; 
                    self.CBU = response.ResponseVM.CBU; 
                    self.Description = response.ResponseVM.Description;
                    } );
            }
        },

        addUpdate(){ 
            let self = this;
            if(this.isUpdate())
            {
                axiosHelpers.axiosPost('Supplier/UpdateSupplierBankAccount', this.getDataToRequest(), this, function(response) 
                    { 
                        var hasError = axiosHelpers.getResponseHasErrors(response);

                        if(!hasError)
                        {
                            notificationHelpers.showSuccess('Exito', 'Se actualizo correctamente el banco.', self); 
                            self.$router.push({ name: 'bancos'})
                        }
                    } );
            }
            else
            {
                axiosHelpers.axiosPost('Supplier/AddSupplierBankAccount', this.getDataToRequest(), this, function(response) 
                    { 
                        var hasError = axiosHelpers.getResponseHasErrors(response);

                        if(!hasError)
                        {
                            notificationHelpers.showSuccess('Exito', 'Se agrego correctamente el banco.', self); 
                            self.$router.push({ name: 'bancos'})
                        }
                    } );
            }
        },

        getDataToRequest()
        {
            return { EntityID: this.EntityID, BankName: this.BankName, CBU: this.CBU, Description: this.Description };
        }
    },
    mounted() {
        this.getData();
    }

  };

 
</script>
<style></style>
